import { render } from "./prod-template-edit.vue?vue&type=template&id=75c7261c&scoped=true"
import script from "./prod-template-edit.vue?vue&type=script&lang=js"
export * from "./prod-template-edit.vue?vue&type=script&lang=js"

import "./prod-template-edit.vue?vue&type=style&index=0&id=75c7261c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c7261c"]])

export default __exports__